import Vue from 'vue'
import App from './App.vue'

import store from './store'

import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'


import config from './config/config'
Vue.prototype.$config = config

// import 'element-ui/lib/theme-chalk/display.css'

// import UIkit from 'uikit'
// import Icons from 'uikit/dist/js/uikit-icons'
// import 'uikit/dist/css/uikit.min.css'

// Vue.prototype.$uikit = UIkit

// UIkit.use(Icons)

Vue.prototype.$axios = axios
Vue.use(ElementUI, {locale})

Vue.config.productionTip = false

new Vue({
  router: router,
  store: store,
  render: h => h(App),
}).$mount('#app')
